module.exports = __webpack_public_path__ + "static/img/planted2.6717e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/misc_3d/plant_wall/planted2.jpg
// module id = 5L6D
// module chunks = 1